<mat-checkbox
    *ngIf="showCheckbox"
    #matCheckbox
    [(ngModel)]="checked"
    [indeterminate]="indeterminate"
    [disabled]="disabled ? true : null"
    (change)="change($event)"
></mat-checkbox>
